import moment from 'moment'
export const setButtonData = (current_source) => {
    if (!current_source) {
        return {
            total: '-',
            isRais: '-',
            percent: '-',
            num: '-'
        }
    }
    const c_income_total = Number(current_source.current.total) || 0
    const l_income_total = Number(current_source.last.total) || 0
    return {
        total: Number(c_income_total),
        isRais: c_income_total - l_income_total > 0,
        percent: !l_income_total ? '-' : Math.abs(((c_income_total / l_income_total - 1) * 100).toFixed(2)),
        num: Number(Math.abs(c_income_total - l_income_total))
    }
}

export const setBarParams = ({
        legend_data,
        sourceData,
        type = 1, // 数据展示形式 1表示 每一天的数据 2表示当天及之前的数据累计
     }) => {
    const xAxis_data = sourceData.current.line_data.map(item => moment(item[0]).get('date')).sort((a, b) => a - b).map(item => item + '日')
    const current_hash = sourceData.current.line_data.reduce((total, item) => {
        total[moment(item[0]).get('date') + '日'] = item[1] || 0
        return total
    }, {})
    const last_month_hash = sourceData.last.line_data.reduce((total, item) => {
        total[moment(item[0]).get('date') + '日'] = item[1] || 0
        return total
    }, {})
    let last_month_data = []
    let current_data = []
    switch (type) {
        case 1:
            last_month_data = xAxis_data.map(item => last_month_hash[item] || 0)
            current_data = xAxis_data.map(item => current_hash[item] || 0)
            break;
        case 2:
            for (let i = 0; i < xAxis_data.length; i++) {
                const key = xAxis_data[i]
                if (i === 0) {
                    last_month_data.push(last_month_hash[key])
                    current_data.push(current_hash[key])
                    continue
                }
                last_month_data.push(math.eval(`${last_month_data[i - 1]} + ${last_month_hash[key] || 0}`).toFixed(0))
                current_data.push(math.eval(`${current_data[i - 1]} + ${current_hash[key] || 0}`).toFixed(0))
            }
        break;
        default:
            break;
    }
    const series = [
        { // 本月数据
            name: legend_data[0],
            data: current_data
        },
        { // 上个月数据
          name: legend_data[1],
          data: last_month_data
        },
       ].map(({name, data}, index) => ({
         z:index === 0 ? 3 : 2,
         name:name,
         type: 'line',
         lineStyle: {
            color: index === 0 ? '#5AC4A0' : '#7FBDF2'
         },
         areaStyle: {
             opacity:0.3,
             color: index === 0 ? '#5AC4A0' : '#7FBDF2'
         },
         data
    }))
    return {
        xAxis_data,
        current_hash,
        last_month_hash,
        series
    }
}